module.exports = __webpack_public_path__ + "img/happyly_redeem_code_phone.421931c.png";